import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AppLoadingState from './common/AppLoadingState';

const DemoVerification = () => {
  const { id, token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyDemoRequest = async () => {
      try {
        // Use the API client's verifyDemo method
        const { redirectUrl } = await api.verifyDemo(id, token);
        
        console.log('Redirecting to verification URL:', redirectUrl);
        
        // Redirect the browser to the verification endpoint
        window.location.href = redirectUrl;
        
        // No need to set loading to false since we're redirecting
        return;
      } catch (err) {
        console.error('Verification error:', err);
        setError('Failed to verify your demo request. Please try again or contact support.');
        setLoading(false);
      }
    };

    verifyDemoRequest();
  }, [id, token]);

  // Only render this component if there's an error or while loading
  // before the redirect happens
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
        {loading && !error && (
          <AppLoadingState
            layout="compact"
            label="Verifying your demo request…"
            className="!min-h-0 py-10"
          />
        )}
        
        {error && (
          <div className="text-center py-12">
            <div className="text-red-500 text-xl mb-4">❌</div>
            <h2 className="text-xl font-semibold mb-2">Verification Failed</h2>
            <p className="text-gray-600 mb-4">{error}</p>
            <button 
              onClick={() => navigate('/request-demo')}
              className="px-4 py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600"
            >
              Request Another Demo
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoVerification; 